import { render, staticRenderFns } from "./ActionList.vue?vue&type=template&id=5482433e&scoped=true"
import script from "./ActionList.vue?vue&type=script&lang=js"
export * from "./ActionList.vue?vue&type=script&lang=js"
import style0 from "./ActionList.vue?vue&type=style&index=0&id=5482433e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5482433e",
  null
  
)

export default component.exports